/**
 * Signal - A reactive value
 *
 * @module @smoothie-framework/ui/state
 */
import { getCurrentObserver, scheduleUpdate } from './context';
import { createObservable, markChanged, trackDependency } from './graph';
import { createPostCommitSubscribers } from './subscriptions';
export function signal(initialValue) {
    let value = initialValue;
    const observable = createObservable();
    const subscribers = createPostCommitSubscribers(() => value);
    const signalFn = () => {
        trackDependency(getCurrentObserver(), observable);
        return value;
    };
    const notify = () => {
        markChanged(observable);
        // Synchronous render schedulers may detach/re-register while notified.
        // Iterate the original subscribers so that swapping slots skips nobody.
        for (const observer of [...observable.observers]) {
            scheduleUpdate(observer);
        }
        subscribers.notify();
    };
    signalFn.peek = () => value;
    signalFn.set = (newValue) => {
        if (!Object.is(value, newValue)) {
            value = newValue;
            notify();
        }
    };
    signalFn.update = (fn) => {
        signalFn.set(fn(value));
    };
    signalFn.subscribe = (fn) => {
        return subscribers.subscribe(fn);
    };
    // Add marker for JSX runtime to detect and preserve reactivity
    signalFn.__isSignal = true;
    return signalFn;
}
//# sourceMappingURL=signal.js.map